import sprintf from 'sprintf-js';
export function translate(term) {
  var substitutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var translations = arguments.length > 2 ? arguments[2] : undefined;
  var defaultReturnValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (typeof term !== 'string' || term === '') {
    return '';
  }
  var lowerCaseTerm = term.toLowerCase();
  var translationExists = typeof translations[lowerCaseTerm] !== 'undefined' && translations[lowerCaseTerm].length > 0;
  var translation = translationExists ? translations[lowerCaseTerm] : term;
  if (!translationExists && defaultReturnValue !== null) {
    return defaultReturnValue;
  }
  var incorrectPercentageSyntax = translation.match(/[0-9]%[^(%]/g);
  if (incorrectPercentageSyntax) {
    // If we encounter a percentage sign not immediately followed by a (, let's fix it
    translation = translation.replace(/%(?!\()/g, '%%');
  }
  try {
    if (Array.isArray(substitutes)) {
      return sprintf.vsprintf(translation, substitutes);
    }
    return sprintf.sprintf(translation, substitutes);
  } catch (e) {
    // @TODO CUSTOMER-1475 This shouldn't happen. This will still result in a visual artifact
    // that's not correct. We should investigate how to catch things like this and log them
    // where a developer can fix it.
    return translation;
  }
}
export default translate;